export default "__VITE_ASSET__Dvd6GmyY__"